export default "__VITE_ASSET__a33e8ea1__"